var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"font-mono"},[_vm._v("LUM "+_vm._s(_vm.metric(_vm.raw).toPrecision(4)))]),_c('micro-bar',{attrs:{"value":_vm.metric(_vm.raw),"benchmark":_vm.avg,"range":_vm.middleFifty}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }